module.exports = __webpack_public_path__ + "static/apple-icon-114x114-65ed83942ac8f771597c728015e7e9ac.png";